import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import CartIcon from '@/assets/templates/icons/cartIcon'

import Layout from './yoga.views'
import ImageWithSkeleton from '@/components/ImageWithSkeleton'

const YogaHero = () => {
  const { template } = useTemplateContext()
  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Header
        backgroundColor='secondary'
        textColor='textPrimary'
      >
        <CommonComponents.Wrapper>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Navigation>
            <CartIcon />
          </Layout.Navigation>
        </CommonComponents.Wrapper>
      </Layout.Header>
      <Layout.Hero
        textColor='textPrimary'
        backgroundColor='primary'
        backgroundOpacity={0.2}
        afterBackgroundImage='https://pr-ecom-account5.web-hosting-stage.app/__static/82c123b9-21ca-42c7-96ba-bff836e33e40/image_desktop'
      >
        <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.HeroImageContainer>
              <ImageWithSkeleton
                src={template.sections.hero.backgroundImage}
                key={template.sections.hero.backgroundImage}
                style={{ height: 500, objectFit: 'cover' }}
              />
            </Layout.HeroImageContainer>
            <Layout.TitleContainer>
              <Layout.Title>{template.sections.hero.title}</Layout.Title>
              <Layout.Subtitle>
                {template.sections.hero.subtitle}
              </Layout.Subtitle>
              <Layout.CTA 
                type="primary"
                textColor="textSecondary"
              >{template.sections.hero.ctaText}</Layout.CTA>
            </Layout.TitleContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default YogaHero
